export * from './auswertungen.components.module';
